import { lazy } from 'react';
import { authRoles } from 'app/auth';

const GeneralSettingsAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.admin,
	routes: [
		{
			path: '/apps/settings/general',
			component: lazy(() => import('./list/Datas'))
		}
	]
};

export default GeneralSettingsAppConfig;
